document.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelector('[data-crg-section-id]');
  if (!el) return;

  const sectionId = el.dataset.crgSectionId;
  const collectionHandle = el.dataset.crgCollectionHandle;
  const filterParam = 'filter.v.option.color';

  if (!collectionHandle) return;

  let abortController = null;

  const filter = async (labels) => {
    if (abortController) abortController.abort();
    abortController = new AbortController();

    const currentSection = document.getElementById(sectionId);
    if (currentSection) currentSection.classList.add('opacity-50', 'pointer-events-none');

    const url = new URL(window.location.href);
    url.searchParams.delete(filterParam);
    if (labels && labels.length > 0) {
      labels.forEach((label) => url.searchParams.append(filterParam, label));
    }
    url.searchParams.set('filter.v.availability', '1');

    const sraParams = new URLSearchParams(url.searchParams);
    sraParams.set('section_id', sectionId);
    const currentView = new URL(window.location.href).searchParams.get('view');
    if (currentView) sraParams.set('view', currentView);
    const sraUrl = `/collections/${collectionHandle}?${sraParams.toString()}`;

    try {
      const response = await fetch(sraUrl, { signal: abortController.signal });
      if (!response.ok) return;

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newSection = doc.getElementById(sectionId);
      if (!newSection) return;

      const productCount = newSection.querySelectorAll('.colour-room-product-wrapper').length;
      const newGrid = newSection.querySelector('.collection-product-grid');
      const isInvisible = newGrid?.classList.contains('invisible');
      console.log(`[Colour Room] "${labels?.join(', ') || 'All'}" → ${productCount} product${productCount !== 1 ? 's' : ''} | grid invisible: ${isInvisible} | url: ${sraUrl}`);

      if (currentSection) {
        currentSection.innerHTML = newSection.innerHTML;
        if (labels && labels.length > 0) {
          const grid = currentSection.querySelector('.collection-product-grid');
          if (grid) grid.classList.remove('invisible');
        }
        currentSection.classList.remove('opacity-50', 'pointer-events-none');
        window.initializeProductCardVariants?.(currentSection);
      }

      history.replaceState(null, '', url.toString());
    } catch (err) {
      if (err.name !== 'AbortError' && currentSection) currentSection.classList.remove('opacity-50', 'pointer-events-none');
    }
  };

  document.addEventListener('colour-room:colour-selected', (e) => filter(e.detail.labels));
});
